import React from 'react';
import { Button } from '../../../Button';
import type { ActionButtonProps } from './ActionButton.types';

export const ActionButton: React.FC<ActionButtonProps> = ({
  dataHook,
  onClick,
  children,
}) => (
  <Button
    skin="premium"
    priority="secondary"
    dataHook={dataHook}
    size="tiny"
    onClick={onClick}
  >
    {children}
  </Button>
);
